module.exports = __webpack_public_path__ + "media/bootstrap-icons/sort-alpha-up-alt-6ef83752.svg";